import axios from '../../axios-dashboard'

import * as actionTypes from './actionTypes'


export const fetchAccountSettingsStart = () => {
    return {
        type: actionTypes.ACCOUNT_SETTINGS_FETCH_START
    }
};

export const fetchAccountSettingsSuccess = (settings) => {
    return {
        type: actionTypes.ACCOUNT_SETTINGS_FETCH_SUCCESS,
        settings: settings
    }
};

export const fetchAccountSettingsFail = (error) => {
    return {
        type: actionTypes.ACCOUNT_SETTINGS_FETCH_FAIL,
        error: error
    }
};

export const fetchAccountSettings = (token) => {
    return dispatch => {
        dispatch(fetchAccountSettingsStart())
        let url = "/account-settings"
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url)
            .then(response => {
                dispatch(fetchAccountSettingsSuccess(response.data))
            })
            .catch(err => {
                dispatch(fetchAccountSettingsFail(err))
            })
    }
};

export const saveCompanyInfoStart = () => {
    return {
        type: actionTypes.COMPANY_INFO_SAVE_START
    }
};

export const saveCompanyInfoSuccess = (info) => {

    return {
        type: actionTypes.COMPANY_INFO_SAVE_SUCCESS,
        companyInfo: info
    }
};

export const saveCompanyInfoFail = (error) => {
    return {
        type: actionTypes.COMPANY_INFO_SAVE_FAIL,
        error: error
    }
};

export const cancelCompanyInfoSave = () => {
    return {
        type: actionTypes.COMPANY_INFO_SAVE_CANCEL
    }
};

export const saveCompanyInfo = (token, info) => {
    return dispatch => {
        dispatch(saveCompanyInfoStart())
        const url = "/account-settings";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, info)
            .then(response => {
                dispatch(saveCompanyInfoSuccess(response.data))
            })
            .catch(err => {
                dispatch(saveCompanyInfoFail(err))
            })
    }
};

export const saveSsoConfigStart = () => {
    return {
        type: actionTypes.SSO_CONFIG_SAVE_START,
    }
}

export const saveSsoConfigSuccess = (config) => {
    return {
        type: actionTypes.SSO_CONFIG_SAVE_SUCCESS,
        ssoConfig: config.ssoConfig,
        spMetadata: config.spMetadata,
    }
}

export const saveSsoConfigFail = (error) => {
    return {
        type: actionTypes.SSO_CONFIG_SAVE_FAIL,
        error: error,
    }
}

export const saveSsoConfig = (token, config) => {
    return dispatch => {
        dispatch(saveSsoConfigStart())
        const url = "/sso-config";
        axios.post(url, config).then(response => {
            dispatch(saveSsoConfigSuccess(response.data))
        }).catch(err => {
            dispatch(saveSsoConfigFail(err.response.data.error))
        })
    }
}

export const addCloudAccountStart = () => {
    return {
        type: actionTypes.ADD_CLOUD_ACCOUNT_START
    }
};

export const addCloudAccountSuccess = (data) => {
    return {
        type: actionTypes.ADD_CLOUD_ACCOUNT_SUCCESS,
        accounts: data.accounts,
        orgs: data.orgs,
        gcpProjects: data.gcpProjects,
    }
};

export const addCloudAccountFail = () => {
    return {
        type: actionTypes.ADD_CLOUD_ACCOUNT_FAIL
    }
};

export const addCloudAccount = (token, accounts, orgs, gcpProjects) => {
    return dispatch => {
        dispatch(addCloudAccountStart());

        const url = "/account-settings";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {accounts: accounts, orgs: orgs, gcpProjects: gcpProjects, action: "updateAccounts"})
            .then(response => {
                dispatch(addCloudAccountSuccess(response.data))
            })
            .catch(err => {
                dispatch(addCloudAccountFail(err.response.data.error))
            })
    }
};

export const editCloudAccountStart = () => {
    return {
        type: actionTypes.EDIT_CLOUD_ACCOUNT_START
    }
};

export const editCloudAccountSuccess = (data) => {
    return {
        type: actionTypes.EDIT_CLOUD_ACCOUNT_SUCCESS,
        accounts: data.accounts,
        orgs: data.orgs,
        gcpProjects: data.gcpProjects,
    }
};

export const editCloudAccountFail = (error) => {
    return {
        type: actionTypes.EDIT_CLOUD_ACCOUNT_FAIL,
        error: error
    }
};

export const editCloudAccount = (token, accounts, orgs, gcpProjects) => {
    return dispatch => {
        dispatch(editCloudAccountStart());

        const url = "/account-settings";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {accounts: accounts, orgs: orgs, gcpProjects: gcpProjects,  action: "updateAccounts"})
            .then(response => {
                dispatch(editCloudAccountSuccess(response.data))
            })
            .catch(err => {
                dispatch(editCloudAccountFail(err.response.data.error))
            })
    }
};

export const deleteCloudAccountStart = () => {
    return {
        type: actionTypes.DELETE_CLOUD_ACCOUNT_START
    }
};

export const deleteCloudAccountSuccess = (data) => {
    return {
        type: actionTypes.DELETE_CLOUD_ACCOUNT_SUCCESS,
        accounts: data.accounts,
        orgs: data.orgs,
    }
};

export const deleteCloudAccountFail = (error) => {
    return {
        type: actionTypes.DELETE_CLOUD_ACCOUNT_FAIL,
        error: error
    }
};

export const deleteCloudAccount = (token, account) => {
    return dispatch => {
        dispatch(deleteCloudAccountStart())

        const url = "/account-settings";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.delete(url, account)
            .then(response => {
                dispatch(deleteCloudAccountSuccess(response.data))
            })
            .catch(err => {
                dispatch(deleteCloudAccountFail(err.response.data.error))
            })
    }
};

export const addUserStart = () => {
    return {
        type: actionTypes.ADD_USER_START
    }
};

export const addUserSuccess = (users) => {
    return {
        type: actionTypes.ADD_USER_SUCCESS,
        users: users
    }
};

export const addUserFail = (error) => {
    return {
        type: actionTypes.ADD_USER_FAIL,
        error: error
    }
};

export const addUser = (token, user) => {
    return dispatch => {
        dispatch(addUserStart())
        const url = "/account-settings";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {users: [user], action: "addUser"})
            .then(response => {
                dispatch(addUserSuccess(response.data))
            })
            .catch(err => {
                dispatch(addUserFail(err.response.data.error))
            })
    }
};

export const editUserStart = () => {
    return {
        type: actionTypes.EDIT_USER_START
    }
};

export const editUserSuccess = (users) => {
    return {
        type: actionTypes.EDIT_USER_SUCCESS,
        users: users
    }
};

export const editUserFail = (error) => {
    return {
        type: actionTypes.EDIT_USER_FAIL,
        error: error
    }
};

export const editUser = (token, user) => {
    return dispatch => {
        dispatch(editUserStart());
        const url = "/account-settings";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {users: [user], action:"updateUser"})
            .then(response => {
                dispatch(editUserSuccess(response.data))
            })
            .catch(err => {
                dispatch(editUserFail(err.response.data.error))
            })
    }
};

export const deleteUserStart = () => {
    return {
        type: actionTypes.DELETE_USER_START
    }
};

export const deleteUserSuccess = (users) => {
    return {
        type: actionTypes.DELETE_USER_SUCCESS,
        users: users
    }
};

export const deleteUserFail = (error) => {
    return {
        type: actionTypes.DELETE_USER_FAIL,
        error: error
    }
};

export const deleteUser = (token, user) => {
    return dispatch => {
        dispatch(deleteUserStart());
        const url = "/account-settings";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {users: [user], action:"deleteUser"})
            .then(response => {
                dispatch(deleteUserSuccess(response.data))
            })
            .catch(err => {
                dispatch(deleteUserFail(err.response.data.error))
            })
    }
};

export const editScopingStart = () =>  {
    return  {
        type: actionTypes.EDIT_SCOPING_START
    }
};

export const editScopingSuccess = (scopings) => {
    return {
        type: actionTypes.EDIT_SCOPING_SUCCESS,
        scopings: scopings,
    }
};

export const editScopingFail = (error) => {
    return {
        type: actionTypes.EDIT_SCOPING_FAIL,
        error: error
    }
};

export const editScopings = (token, scopings) => {
    return dispatch => {
        dispatch(editScopingStart());
        const url = "/account-settings";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {scopings: scopings, action:"updateScopings"})
            .then(response => {
                dispatch(editScopingSuccess(response.data))
            }).catch(err => {
                dispatch(editScopingFail(err.response.data.error))
        })
    }
};

export const deleteSessionStart = () => {
    return {
        type: actionTypes.DELETE_SESSION_START
    }
};

export const deleteSessionSuccess = (userSessions) => {
    return {
        type: actionTypes.DELETE_SESSION_SUCCESS,
        userSessions: userSessions,
    }
};

export const deleteSessionFail = (error) => {
    return {
        type: actionTypes.DELETE_SESSION_FAIL,
        error: error
    }
};

export const deleteSession = (token, sessionToken) => {
    return dispatch => {
        dispatch(deleteSessionStart());
        const url = "/account-settings";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {userSessions: [{token: sessionToken}], action:"delete_user_session"})
            .then(response => {
                dispatch(deleteSessionSuccess(response.data))
            })
            .catch(err => {
                dispatch(deleteSessionFail(err.response.data.error))
            })
    }
};

export const deleteApiKeyStart = () => {
    return {
        type: actionTypes.DELETE_APIKEY_START
    }
};

export const deleteApiKeySuccess = () => {
    return {
        type: actionTypes.DELETE_APIKEY_SUCCESS
    }
};

export const deleteApiKeyFail = (error) => {
    return {
        type: actionTypes.DELETE_APIKEY_FAIL,
        error: error
    }
};

export const deleteApiKey = (token, key) => {
    return dispatch => {
        dispatch(deleteApiKeyStart());
        const url = "/account-settings";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {action:"deleteApiKey", apiKey: {key: key}})
            .then(response => {
                dispatch(deleteApiKeySuccess())
            })
            .catch(err => {
                dispatch(deleteApiKeyFail(err.response.data.error))
            })
    }
};

export const generateApiKeyStart = () => {
    return {
        type: actionTypes.GENERATE_APIKEY_START
    }
};

export const generateApiKeySuccess = (apiKey) => {
    return {
        type: actionTypes.GENERATE_APIKEY_SUCCESS,
        apiKey: apiKey
    }
};

export const generateApiKeyFail = (error) => {
    return {
        type: actionTypes.GENERATE_APIKEY_FAIL,
        error: error
    }
};

export const generateApiKey = (token) => {
    return dispatch => {
        dispatch(generateApiKeyStart());
        const url = "/account-settings";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {action:"generateApiKey"})
            .then(response => {
                dispatch(generateApiKeySuccess(response.data))
            })
            .catch(err => {
                dispatch(generateApiKeyFail(err.response.data.error))
            })
    }
};

export const changePasswordStart = ()=> {
    return {
        type: actionTypes.CHANGE_PASSWORD_START
    }
};

export const changePasswordSuccess = (token) => {
    sessionStorage.removeItem("token");
    sessionStorage.setItem("token", token.token);
    return {
        type: actionTypes.CHANGE_PASSWORD_SUCCESS,
        token: token.token,
    }
};

export const changePasswordFail = (error) => {
    return {
        type: actionTypes.CHANGE_PASSWORD_FAIL,
        error: error,
    }
};

export const changePassword = (token, oldPassword, password) => {
    return dispatch => {
        dispatch(changePasswordStart())
        const url = "/account-settings"
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {action: "changePassword", passwords: {oldPassword: oldPassword, newPassword: password}})
            .then(response => {
                dispatch(changePasswordSuccess(response.data))
            }).catch(err => {
                dispatch(changePasswordFail(err.response.data.error))
        })
    }
};
